import React from 'react'
import { FlowCardProps } from './types'
import styles from './Flow.module.css'

export default function FlowCard({
    image,
    title,
    subtitle,
    description,
    boxImage,
    boxImageAlt,
    imageAlt,
}: FlowCardProps) {
    return (
        <li>
            <div className={styles.flowImage}>
                <img src={image} alt={imageAlt ?? ''} />
            </div>
            <div className={styles.flowBox}>
                <h2>{title}</h2>
                <h3>{subtitle}</h3>
                <p>{description}</p>
                {boxImage && <img src={boxImage} alt={boxImageAlt ?? ''} />}
            </div>
        </li>
    )
}
